/* ============================================================
   PARCU — country based translation of the fixed UI copy

   The product page collapsible does not use Shopify's language
   system. It reads localization.country.iso_code and swaps
   hardcoded strings, which is why the tabs turn into Groessen or
   Tallas when the country changes while document lang stays en.
   This puts the rest of the fixed copy on the same country basis.
   Dictionaries: parcu-i18n through parcu-i18n5.

   NOT touched: the one line description unique to each product,
   filter values, and the graphic name in a product title. Those
   are product data. The model lines, the spec lines and the
   garment words at the end of a product name ARE templated, so
   only the words around the data change. Collection titles are
   translated by handle, a fixed list, not by text.
   ============================================================ */

(function () {
    'use strict';

    var T = window.PARCU_T;
    var T2 = window.PARCU_T2 || {};
    var T3 = window.PARCU_T3 || {};
    var T5 = window.PARCU_T5 || {};
    if (!T || !T.map) return;        /* English, or no dictionary */

    var MAP = T.map;
    var BAR = T.bar || {};           /* colour and category words */

    /* The English side of the positional arrays in parcu-i18n3,
       parcu-i18n4 and parcu-i18n5. Kept here once instead of in
       every country branch of those files. Order is the contract:
       change a list here and the arrays there move with it. */
    var DET_EN = [
        'The Chasing Paradise wordmark is embroidered across the back.',
        'The Paradise wordmark is embroidered across the back in gold.',
        'The Paradise monogram is stitched in.',
        'The Paradise wordmark runs across the chest.',
        'The Paradise wordmark flashes across the chest in royal yellow.',
        'An octopus is embroidered at the chest.',
        'Stars and PARCU® are embroidered across the back.'
    ];
    var COLL_EN = [
        'baby-blue', 'heavyweight', 'heavyweight-hoodie',
        'april-heavyweight', 'may-heavyweight', 'june-heavyweight',
        'july', 'august', 'september',
        'world-cup-heavyweight-tee-collection'
    ];
    var NAV_EN = [
        'Heavyweight tees', 'Heavyweight Hoodies', 'Sizing', 'Support',
        'Our journey', 'Contact us', 'FAQs and Policies', 'Returns Portal'
    ];
    var MAP_EN = [
        'Shipping discounts are shown at checkout once you add an address.',
        'Subtotal', 'Checkout', 'Your cart is empty', 'Continue shopping',
        'Cart', 'Search', 'Log in', 'Language',
        'More payment options', 'MORE PAYMENT OPTIONS',
        'Discount', 'Discount code', 'Apply', 'Applying...',
        "This discount code can't be applied to your cart.",
        "We couldn't update your discounts. Please try again.",
        'Check out →', 'Check out', 'Spend', 'more for free shipping!'
    ];
    var MAP5_EN = ['Register', 'Close', 'Menu', 'View cart'];

    function zip(enKeys, vals) {
        var o = {}, i;
        if (!vals || !vals.length) return o;
        for (i = 0; i < enKeys.length && i < vals.length; i++) {
            if (vals[i]) o[enKeys[i]] = vals[i];
        }
        return o;
    }

    var DET = zip(DET_EN, T3.det);
    var COLL = zip(COLL_EN, T3.coll);
    var NAV = T3.nav ? zip(NAV_EN, T3.nav) : null;   /* applied late */
    var T3MAP = zip(MAP_EN, T3.map);
    var T5MAP = zip(MAP5_EN, T5.map);
    var k;
    /* Merged so the tree walk only has to run once. The menu is
       kept out of MAP on purpose, see menuLabels below. */
    if (T2.map) { for (k in T2.map) { if (T2.map.hasOwnProperty(k)) MAP[k] = T2.map[k]; } }
    for (k in T3MAP) { if (T3MAP.hasOwnProperty(k)) MAP[k] = T3MAP[k]; }
    for (k in T5MAP) { if (T5MAP.hasOwnProperty(k)) MAP[k] = T5MAP[k]; }

    function lookup(dict, key) {
        if (dict[key]) return dict[key];
        /* The colour legend renders as "Colour: <span>Blue</span>",
           so its text node is "Colour: " and never matches bare. */
        if (key.charAt(key.length - 1) === ':') {
            var bare = key.slice(0, -1).trim();
            if (dict[bare]) return dict[bare] + ':';
        }
        return null;
    }

    /* Whole-node exact matching only. A node reading "Black" is a
       swatch label and is translated; "Black Camel heavyweight tee"
       is a product title and is not an exact match, so the title is
       left to nameSuffix. The cap just skips long prose quickly. */
    function swap(root, dict) {
        if (!root || !dict) return;
        var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
        var hits = [], n;
        while ((n = w.nextNode())) {
            var raw = n.nodeValue, key = raw.trim();
            if (!key || key.length > 90) continue;
            var to = lookup(dict, key);
            if (to && to !== key) hits.push([n, raw, key, to]);
        }
        for (var i = 0; i < hits.length; i++) {
            hits[i][0].nodeValue = hits[i][1].replace(hits[i][2], hits[i][3]);
        }
    }

    /* The header menu has to wait. parcu-header.js builds the
       category bar by matching the menu items on their English
       labels, so translating the menu first would leave the bar
       empty. Once the bar exists the menu is safe. The dropdown
       and the phone drawer list the same words as the bar, so they
       take the bar dictionary too, scoped to the header because
       All and White are too common site wide. */
    function menuLabels() {
        if (!document.querySelector('.parcu-subbar')) return;
        if (NAV) swap(document.body, NAV);
        swap(document.getElementById('mainHeader'), BAR);
        swap(document.getElementById('mobmenu'), BAR);
    }

    /* Matched by pattern because the theme uses a typographic
       apostrophe in "You’d also like" and a straight one elsewhere. */
    function alsoLike() {
        if (!T2.alsoLike) return;
        var hs = document.querySelectorAll('h1,h2,h3,.gs-title,.title');
        for (var i = 0; i < hs.length; i++) {
            var t = hs[i].textContent.trim();
            if (/^you.{0,3}d also like$/i.test(t) && t !== T2.alsoLike) {
                hs[i].textContent = T2.alsoLike;
            }
        }
    }

    /* "35 reviews" and "(35 reviews)". The number is data and is
       kept; only the word is swapped. reviewsWord carries its own
       leading space where one is needed, so CJK joins the digits. */
    function reviewCount() {
        if (!T2.reviewsWord) return;
        var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
        var hits = [], n;
        while ((n = w.nextNode())) {
            if (/\d[\d,]*\s+reviews?\b/i.test(n.nodeValue)) hits.push(n);
        }
        for (var i = 0; i < hits.length; i++) {
            hits[i].nodeValue = hits[i].nodeValue.replace(
                /(\d[\d,]*)\s+reviews?\b/gi,
                function (m, num) { return num + T2.reviewsWord; }
            );
        }
    }

    /* The checkout line is three nodes, because shipping is a link
       to the policy. Word order moves between languages, so the
       sentence is rebuilt rather than swapped node by node, {s}
       marking the link. There are two of them: the cart page says
       taxes are calculated, the drawer says they are included. */
    var TAX = [
        ['taxes, discounts and shipping calculated at checkout.', 'a'],
        ['taxes included. discounts and shipping calculated at checkout.', 'b']
    ];

    function taxLine() {
        if (!T3.shipWord) return;
        var as = document.querySelectorAll('a');
        for (var i = 0; i < as.length; i++) {
            if (as[i].textContent.trim().toLowerCase() !== 'shipping') continue;
            var box = as[i].parentElement;
            if (!box) continue;
            var norm = box.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
            var tpl = null, j;
            for (j = 0; j < TAX.length; j++) {
                if (norm !== TAX[j][0]) continue;
                tpl = TAX[j][1] === 'a' ? T3.taxLine : T5.taxLine2;
                break;
            }
            if (!tpl) continue;
            var link = as[i].cloneNode(false);
            link.textContent = T3.shipWord;
            var parts = tpl.split('{s}');
            box.textContent = '';
            box.appendChild(document.createTextNode(parts[0]));
            box.appendChild(link);
            if (parts[1]) box.appendChild(document.createTextNode(parts[1]));
        }
    }

    /* Model lines: "Name, 186cm / 6'1", wearing size Medium (Boxy
       Fit)" on a tee, "... (in Grey)" on a hoodie. Only the words
       translate; the name, height and size are data. */
    function modelLines() {
        var boxes = document.querySelectorAll('.pm-line, .parcu-modelnote');
        for (var i = 0; i < boxes.length; i++) {
            var ps = boxes[i].querySelectorAll('p');
            for (var j = 0; j < ps.length; j++) {
                var el = ps[j], s = el.textContent, out = s;
                if (T.wearingSize) out = out.replace(/wearing size/gi, T.wearingSize);
                if (T.classicFit) out = out.replace(/Classic Fit/gi, T.classicFit);
                if (T.boxyFit) out = out.replace(/Boxy Fit/gi, T.boxyFit);
                if (T3.inColour) {
                    out = out.replace(/\(in ([A-Za-z][A-Za-z ]*)\)/g, function (m, c) {
                        var col = c.trim();
                        return '(' + T3.inColour.replace('{c}', BAR[col] || col) + ')';
                    });
                }
                if (out !== s) el.textContent = out;
            }
        }
    }

    /* The standard spec lines. Three shapes on a tee: with a colour,
       with a colour and a back print, and one older product with no
       colour at all, which is why the colour group may be empty and
       the result is trimmed. One shape on a hoodie, in two cuts.
       Anything else in the description, the one line written per
       product above all, fails every test. All are idempotent. */
    var SPEC = /^(.*?)\s*heavyweight\s+280\s?gsm\s+100%\s+cotton tee( with back print)? in classic and boxy fit\.?$/i;
    var HOOD = /^(.+?)\s+500\s?gsm brushed cotton-blend fleece, cut oversized and boxy with (balloon sleeves into ribbed cuffs|a full zip, kangaroo pocket and ribbed cuffs)\.\s*(.*)$/i;
    var PIC = /^Pictured in ([A-Za-z][A-Za-z ]*)\.$/i;

    function specLine() {
        var ps = document.querySelectorAll('product-description p, .description .rte p');
        for (var i = 0; i < ps.length; i++) {
            var txt = ps[i].textContent.trim(), m, col;

            m = SPEC.exec(txt);
            if (m) {
                var tpl = m[2] ? (T5.specBack || T2.spec) : T2.spec;
                if (tpl) {
                    col = m[1].trim();
                    ps[i].textContent = tpl.replace('{c}', BAR[col] || col).trim();
                }
                continue;
            }

            m = PIC.exec(txt);
            if (m && T5.pictured) {
                col = m[1].trim();
                ps[i].textContent = T5.pictured.replace('{c}', BAR[col] || col);
                continue;
            }

            if (T3.hoodie) {
                m = HOOD.exec(txt);
                if (m) {
                    col = m[1].trim();
                    var isZip = /full zip/i.test(m[2]);
                    var ht = (isZip && T3.hoodieZip) ? T3.hoodieZip : T3.hoodie;
                    var line = ht.replace('{c}', BAR[col] || col);
                    /* The sentence after the spec names the artwork.
                       Fixed set, so a lookup, and anything unlisted
                       stays English rather than being dropped. A CJK
                       full stop carries its own spacing. */
                    var rest = (m[3] || '').trim();
                    if (rest) {
                        line += (/[。．]$/.test(line) ? '' : ' ') + (DET[rest] || rest);
                    }
                    ps[i].textContent = line;
                }
            }
        }
    }

    /* Product names end in heavyweight tee or heavyweight hoodie.
       The graphic name in front is the product and stays; only the
       garment words move. A node that starts with heavyweight is a
       menu label or a collection title, left to the dictionaries. */
    function nameSuffix() {
        if (!T5.teeWord && !T5.hoodieWord) return;
        var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
        var hits = [], n;
        while ((n = w.nextNode())) {
            var t = n.nodeValue;
            if (t.length > 160 || /^\s*heavyweight/i.test(t)) continue;
            if (/heavyweight (tee|hoodie)/i.test(t)) hits.push(n);
        }
        for (var i = 0; i < hits.length; i++) {
            var v = hits[i].nodeValue;
            if (T5.hoodieWord) v = v.replace(/heavyweight hoodies?\b/gi, T5.hoodieWord);
            if (T5.teeWord) v = v.replace(/heavyweight tees?\b/gi, T5.teeWord);
            hits[i].nodeValue = v;
        }
    }

    function colourValue() {
        var legs = document.querySelectorAll('legend.form__label');
        for (var i = 0; i < legs.length; i++) {
            var sp = legs[i].querySelector('span');
            if (!sp) continue;
            var v = sp.textContent.trim();
            if (BAR[v] && BAR[v] !== v) sp.textContent = BAR[v];
        }
    }

    /* Collection titles, keyed by handle printed server side, so a
       heading only changes when the page really is that collection.
       Handles with no entry fall back to the colour words, which is
       what the colour collections need. */
    function collTitle() {
        var h = window.PARCU_COLLH, from = window.PARCU_COLLT;
        if (!h || !from) return;
        var to = COLL[h] || BAR[from] || null;
        if (!to || to === from) return;
        var els = document.querySelectorAll('h1, h2, .breadcrumbs a, .breadcrumbs span, nav[aria-label*="readcrumb"] a, nav[aria-label*="readcrumb"] span');
        for (var i = 0; i < els.length; i++) {
            if (els[i].textContent.trim() === from) els[i].textContent = to;
        }
    }

    function run() {
        swap(document.body, MAP);
        swap(document.querySelector('.parcu-subbar'), BAR);
        menuLabels();
        colourValue();
        collTitle();
        alsoLike();
        reviewCount();
        taxLine();
        modelLines();
        specLine();
        nameSuffix();
    }

    function boot() {
        run();
        /* The category bar is built by parcu-header.js, Judge.me
           paints late, the cart drawer is built on open, and
           changing size re-renders the buy button, so re-run on DOM
           changes. Debounced, because a tree walk on every mutation
           would be costly, and every swap is idempotent so a late
           pass is harmless. */
        if (!window.MutationObserver) return;
        var timer;
        new MutationObserver(function () {
            clearTimeout(timer);
            timer = setTimeout(run, 120);
        }).observe(document.body, { childList: true, subtree: true });
        window.addEventListener('load', run);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();